import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import DefaultUserAvatar from 'assets/svgs/common/default-avatar.svg';
import {ReactComponent as DeleteIcon} from 'assets/svgs/categories/delete.svg';

export default ({
  setSelectedItem,
  items,
  setItems,
  tableData,
  targetRole,
  teamId,
  centerizeForm,
}) => {
  const staff = useSelector((state) => state.team.staff);
  const existingUserForm = useRef();
  const deleteButton = useRef();
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const margin = centerizeForm(existingUserForm.current.offsetWidth);
    existingUserForm.current.style.marginRight = `${margin}px`;
    deleteButton.current.style.right = `${margin + 23}px`;
  }, []);

  const handleUserClick = useCallback(
    (user) => {
      setSelectedUser(user);
      setTimeout(() => {
        setSelectedUser(null);
        const index = items.findIndex((item) => item._id === 'existing_user');
        const existingUser = tableData.selectExistingUser(
          targetRole._id,
          user,
          teamId
        );
        console.log(existingUser);
        items[index] = existingUser;
        console.log(items);
        setItems([...items]);
        setSelectedItem(existingUser);
      }, 1000);
    },
    [items]
  );

  const onCancel = useCallback(() => {
    setSelectedItem(null);
    const index = items.findIndex((item) => item._id === 'existing_user');
    setTimeout(() => {
      setItems((value) => {
        value.splice(index, 1);
        return [...value];
      });
    }, 500);
  }, [items]);

  return (
    <div className="position-relative existing-user-form">
      <div
        className="add-cat-row position-absolute delete-action-button"
        ref={deleteButton}
      >
        <button
          type="button"
          onClick={onCancel}
          className="btn-link position-absolute"
        >
          <DeleteIcon />
        </button>
      </div>
      <div className="existing-user-list" ref={existingUserForm}>
        {staff.map((user) => (
          <div
            key={user._id}
            className={`user-card ${
              selectedUser && user._id === selectedUser._id
                ? 'user-card-active'
                : ''
            }`}
            onClick={() => handleUserClick(user)}
          >
            <img
              src={user.avatar || DefaultUserAvatar}
              alt={`${user.firstName} ${user.lastName}`}
            />
            {`${user.firstName} ${user.lastName}`}
          </div>
        ))}
      </div>
    </div>
  );
};
